import axios from 'axios'
import config from '../../config'
import { useMainStore } from '@/store/Pinia/useMain.store'

// Tamanho mínimo do OTP do Bird ID Hub (6 dígitos numéricos)
const MIN_VALID_TOKEN_LENGTH = 6

const server = axios.create({
  baseURL: `${config.app.urlServer}/`,
})

// Adiciona flag 'certificate_cloud: HUB' às requisições quando há sessão ativa do Hub
// Isso informa ao backend que a autenticação foi via Hub (token de 3h) ao invés de token local
server.interceptors.request.use((config) => {
  const mainStore = useMainStore()
  const validToken = mainStore.getValidBirdSessionToken

  // Adiciona flag apenas em requisições com body (POST/PUT/PATCH)
  if (validToken.length >= MIN_VALID_TOKEN_LENGTH && config.data) {
    config.data = {
      ...config.data,
      certificate_cloud: 'HUB',
    }
  }

  return config
})

const serverPanel = axios.create({
  baseURL: `${config.app.urlServerPanel}/`,
})

export { server, serverPanel }
